export class SearchHeaderElement extends HTMLElement {
  private resultsHeading: HTMLElement | null = null
  private currentResultsCount: number = 0

  connectedCallback() {
    this.initializeElements()
    this.initializeFromAttributes()
    this.addEventListeners()
  }

  disconnectedCallback() {
    this.removeEventListeners()
  }

  /**
   * Initialize DOM element references
   */
  private initializeElements() {
    this.resultsHeading = this.querySelector('h4')
  }

  /**
   * Initialize current results count from data attribute
   */
  private initializeFromAttributes() {
    const dataResults = this.getAttribute('data-results')
    this.currentResultsCount = dataResults ? parseInt(dataResults, 10) : 0
  }

  /**
   * Add event listeners
   */
  private addEventListeners() {
    // Listen for search results updates from the product grid
    document.addEventListener('searchResultsUpdated', this.handleSearchResultsUpdated.bind(this))
  }

  /**
   * Remove event listeners
   */
  private removeEventListeners() {
    document.removeEventListener('searchResultsUpdated', this.handleSearchResultsUpdated.bind(this))
  }

  /**
   * Handle search results count update
   */
  private handleSearchResultsUpdated(event: CustomEvent) {
    try {
      const { resultsCount, searchTerms } = event.detail

      if (typeof resultsCount === 'number') {
        this.updateResultsCount(resultsCount, searchTerms)
      }
    } catch {
      // Silently handle any errors
    }
  }

  /**
   * Update the results count display
   */
  private updateResultsCount(count: number, searchTerms?: string) {
    // Update data attribute
    this.setAttribute('data-results', count.toString())
    this.currentResultsCount = count

    // Update heading text
    if (this.resultsHeading) {
      let headingText = `${count} Result${count !== 1 ? 's' : ''}`

      if (searchTerms && searchTerms.trim()) {
        headingText += ` for "${searchTerms}"`
      }

      this.resultsHeading.textContent = headingText
    }
  }
}
